import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import Combobox, { ComboboxSectionTitle, ComboboxOption } from "../Combobox";
import filterTree from "./filterTree";
import getSelectedItem from "./getSelectedItem";
import normalizeInputValue from "./normalizeInputValue";

function idAsValue(item) {
  return item ? item.id : null;
}

function displayAsLabel(item) {
  return item ? item.display : "";
}

var Select = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (event) {
      var isOpen = event.isOpen;

      if (isOpen !== undefined) {
        _this.setState({
          isOpen: isOpen
        });
      }

      var onStateChange = _this.props.onStateChange;

      if (onStateChange) {
        onStateChange(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (selectedItem) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onChangeValue = _this$props.onChangeValue,
          toValue = _this$props.toValue;

      if (onChange) {
        onChange(selectedItem);
      }

      if (onChangeValue) {
        onChangeValue(toValue(selectedItem));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredItems", function (comboboxProps) {
      var selectedItem = comboboxProps.selectedItem,
          toLabel = comboboxProps.toLabel;
      var inputValue = comboboxProps.inputValue;
      var items = _this.props.items;
      inputValue = normalizeInputValue(inputValue);

      if (inputValue === "" || normalizeInputValue(toLabel(selectedItem)) === inputValue) {
        return items;
      }

      return filterTree(items, function (item) {
        return normalizeInputValue(toLabel(item)).indexOf(inputValue) !== -1;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (comboboxProps) {
      var items = _this.getFilteredItems(comboboxProps);

      var toValue = comboboxProps.toValue,
          toLabel = comboboxProps.toLabel;
      var menu = [];
      var index = 0;

      var renderItem = function renderItem(item) {
        if (item.children != null) {
          var label = toLabel(item);
          menu.push(___EmotionJSX(ComboboxSectionTitle, {
            key: label
          }, label));
          item.children.forEach(renderItem);
        } else {
          menu.push( // For some reason, the `highlightedIndex` and `getItemProps` props
          // from the ComboboxChildrenProps are not being correctly inferred
          // when creating the ComboboxOption.
          // $FlowFixMe
          ___EmotionJSX(ComboboxOption, _extends({}, comboboxProps, {
            key: toValue(item),
            item: item,
            index: index
          }), _this.props.renderOption(_extends({
            item: item,
            index: index
          }, comboboxProps))));
          index += 1;
        }
      };

      items.forEach(renderItem);
      return menu;
    });

    _this.state = {
      isOpen: false
    };

    _this.triggerOnChangeFromDefaultSelectedValue(props);

    return _this;
  }

  var _proto = Select.prototype;

  _proto.triggerOnChangeFromDefaultSelectedValue = function triggerOnChangeFromDefaultSelectedValue(_ref) {
    var initialSelectedValue = _ref.initialSelectedValue,
        props = _objectWithoutPropertiesLoose(_ref, ["initialSelectedValue"]);

    if (props.selectedItem != null) {
      return;
    }

    var selectedItem = getSelectedItem(_extends({}, props, {
      selectedValue: initialSelectedValue
    }));

    if (selectedItem) {
      this.onChange(selectedItem);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        openUntilSelected = _this$props2.openUntilSelected,
        props = _objectWithoutPropertiesLoose(_this$props2, ["openUntilSelected"]);

    var selectedItem = getSelectedItem(this.props);
    var isOpen = this.state.isOpen;

    if (openUntilSelected && !this.props.disabled && !selectedItem) {
      isOpen = true;
    }

    return ___EmotionJSX(Combobox, _extends({}, props, {
      isOpen: isOpen,
      selectedItem: selectedItem,
      onStateChange: this.onStateChange,
      onChange: this.onChange
    }), this.renderMenu);
  };

  return Select;
}(React.Component);

_defineProperty(Select, "defaultProps", {
  allowClear: false,
  selectedItem: undefined,
  selectedValue: undefined,
  initialSelectedValue: undefined,
  toLabel: displayAsLabel,
  toValue: idAsValue,
  onChange: undefined,
  onChangeValue: undefined,
  onStateChange: undefined,
  disabled: false,
  openUntilSelected: false,
  renderOption: function renderOption(_ref2) {
    var item = _ref2.item,
        toLabel = _ref2.toLabel;
    return toLabel(item);
  }
});

export { Select as default };